if (!customElements.get('header-search')) {
  customElements.define(
    'header-search',
    // eslint-disable-next-line no-undef
    class HeaderSearch extends window.BAO.CustomElement() {
      setupListeners () {
        super.setupListeners()

        if (this.hasEl('trigger')) {
          this.els.trigger.elements.forEach(trigger => {
            this.listeners.add(trigger, 'click', this.handleTrigger.bind(this))
          })
        }

        if (this.dataset.searchContext === 'mobile-menu') {
          this.listeners.add(this, 'click', this.handleMenuTrigger.bind(this))
          this.listeners.add(this, 'focus', this.handleMenuTrigger.bind(this))
        }

        this.listeners.add(document.body, 'click', this.handleClose.bind(this))

        this.listeners.add(document.body, 'focus', this.handleClose.bind(this))

        this.listeners.add(document, 'keyup', this.handleEscape.bind(this))
      }

      handleTrigger (event) {
        const trigger = event.target.closest(this.els.trigger.selector)
        if (
          !trigger ||
          document
            .querySelector('body')
            .classList.contains('util-DrawersOpen') ||
          this.dataset.searchContext !== 'header'
        ) {
          return
        }

        this.isActive =
          this.els.form.element.getAttribute('aria-hidden') === 'true'
      }

      handleMenuTrigger (event) {
        if (
          (this.closest('.drw-Drawer-menu') && this.isActive) ||
          this.dataset.searchContext !== 'mobile-menu'
        ) {
          return
        }

        this.isActive =
          this.els.form.element.getAttribute('aria-hidden') === 'true'
      }

      handleClose (event) {
        const headerSearch = event.target.closest(this.tagName)
        const trigger = event.target.closest(this.els.trigger.selector)
        const algoliaDropdown = event.target.closest('.aa-Panel')
        const quickbuyClick = event.target.closest(
          '[data-search-quickbuy-trigger]',
        )

        const closeAlgoliaButton = event.target.closest('.aa-Close')
        const algoliaBackdrop = event.target.closest('.aa-PanelBackdrop')

        const drawerSearch = event.target.closest(
          '.drw-Drawer-menu .hd-Banner_Search',
        )
        const drawersOpen = document
          .querySelector('body')
          .classList.contains('util-DrawersOpen')

        if (
          (headerSearch || trigger || algoliaDropdown || quickbuyClick) &&
          !closeAlgoliaButton &&
          !algoliaBackdrop
        ) {
          return
        }

        if (drawerSearch && drawersOpen) {
          return
        }

        this.isActive = false
      }

      // IOS Hack from Nike to open the keyboard when the search is opened
      focusAndOpenKeyboard (el, timeout) {
        if (!timeout) {
          timeout = 100
        }
        if (el) {
          // Align temp input element approximately where the input element is
          // so the cursor doesn't jump around
          const __tempEl__ = document.createElement('input')
          __tempEl__.style.position = 'absolute'
          __tempEl__.style.top = `${el.offsetTop + 7}px`
          __tempEl__.style.left = `${el.offsetLeft}px`
          __tempEl__.style.height = 0
          __tempEl__.style.opacity = 0
          // Put this temp element as a child of the page <body> and focus on it
          document.body.appendChild(__tempEl__)
          __tempEl__.focus()

          // The keyboard is open. Now do a delayed focus on the target element
          setTimeout(() => {
            el.focus()
            el.click()
            // Remove the temp element
            document.body.removeChild(__tempEl__)
          }, timeout)
        }
      }

      handleEscape (event) {
        if (event.key === 'Escape') {
          this.isActive = false
        }
      }

      hasEl (elementName) {
        return this.els[elementName] && this.els[elementName].exists
      }

      set isActive (boolean) {
        this._isActive = boolean
        this.els.form.element.setAttribute('aria-hidden', (!boolean).toString())
        this.els.trigger.element.setAttribute('aria-hidden', boolean.toString())

        if (boolean === true) {
          this.classList.add('hd-Search-active')
        } else {
          this.classList.remove('hd-Search-active')
        }

        document.body.dataset.searchActive = boolean.toString()

        if (boolean === true) {
          if (this.els?.input?.element) this.els.input.element.focus()
          this.focusAndOpenKeyboard(this.querySelector('.aa-Input'), 0)
        }
      }

      get isActive () {
        return this._isActive
      }
    },
  )
}
